"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const core_2 = require("@material-ui/core");
exports.useStyle = styles_1.makeStyles({
    textbox: {
        minWidth: "100px",
        width: "100%",
    }
});
function Dropdown(props) {
    const classes = exports.useStyle();
    let i = 0;
    let itemList = [];
    if (props.items !== undefined) {
        props.items.map(item => {
            return itemList.push(react_1.default.createElement(core_2.MenuItem, { key: i++, value: props.getOptionValue(item) }, props.getOptionLabel(item)));
        });
    }
    return (react_1.default.createElement(core_1.Grid, { item: true },
        react_1.default.createElement(core_1.TextField, { className: classes.textbox, id: props.id, select: true, label: props.label, value: props.value === undefined ? "" : props.value, onChange: props.onChange, helperText: (props.helperText === undefined ? "" : props.helperText), margin: (props.margin === undefined ? "dense" : props.margin), name: props.name, InputProps: {
                disableUnderline: true,
                style: { color: "#000" }
            } }, itemList)));
}
exports.default = Dropdown;
//# sourceMappingURL=Dropdown.js.map